import React from 'react'
import { ArrowBackIos } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import "./PageNotFound.css"
import { Helmet } from 'react-helmet-async'

function PageNotFound() {
  return (
    <div className='PageNotFound'>
        <Helmet >
        <title>404error</title>
        <meta name="description" content="access denied"/>
        <link rel="canonical" href="*" />
      </Helmet>
      <div className="PageNotFound_container">
      
      <Link to="/notuser">
        <div className='pagenotfound_icon'>
            <ArrowBackIos className='icons'/>
            <p>Back</p>
        </div>
       </Link>

       <div className='pagenotfound_body'>
        <p>404</p>
        <span>Page requesting not found</span>
       </div>
      </div>
    </div>
  )
}

export default PageNotFound
